if (!customElements.get('bewow-faq-grid')) {
  class BewowFaqGrid extends HTMLElement {
    constructor() {
      super();
      this.details = Array.from(this.querySelectorAll('details'));
      this.onBlockSelect = this.handleBlockSelect.bind(this);

      this.details.forEach((details) => {
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        details.addEventListener('toggle', () => {
          if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (!details.open || this.dataset.singleOpen !== 'true') return;
          this.details.forEach((item) => {
            if (item !== details) item.removeAttribute('open');
          });
        });
      });

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    handleBlockSelect(event) {
      const item = event.target.closest('.bewow-faq__item');
      if (!item || item.closest('bewow-faq-grid') !== this) return;
      const details = item.querySelector('details');
      if (details) details.setAttribute('open', '');
    }
  }

  customElements.define('bewow-faq-grid', BewowFaqGrid);
}
